import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { styled } from '../../utils';
const HighlightSpan = styled('span')(({ theme }) => ({
    color: theme.palette.primary.lighter,
}));
// these are special characters used by the elastic search tokenizer to generate tokens
// so we also use them here to split texts on the frontend. we need also split if we have a '/' between matches 'keyqord: KUE/Abmeldung '
const SPLITTING_CHARACTERS = /[-|@ ]|(?<=<\/strong>)\/(?=<strong>)/g;
function escapeRegExp(str) {
    return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
}
export const HighlightedText = ({ fullText, highlightedText, }) => {
    if (!fullText)
        return null;
    const keywords = highlightedText
        .split(SPLITTING_CHARACTERS)
        .filter((text) => !!text);
    // get the first match for the current text
    const matchedText = keywords.reduce((matched, keyword) => {
        if (matched !== null)
            return matched;
        const res = fullText.match(new RegExp(escapeRegExp(keyword), 'i'));
        if (res !== null) {
            return res[0];
        }
        return null;
    }, null);
    if (matchedText === null) {
        // nothing found
        return _jsx("span", { children: fullText });
    }
    const [beforeMatch, ...afterMatch] = fullText.split(matchedText);
    return (_jsxs("span", { children: [beforeMatch, _jsx(HighlightSpan, { children: matchedText }), afterMatch.join(matchedText)] }));
};
const StrongStyled = styled('strong')(({ theme }) => ({
    fontWeight: theme.typography.fontWeightBold,
}));
/**
 * `getElasticHighlightRestText` is used to output the
 * search strings as substrings between <strong> tags,
 * for <ElasticHighlightText/> to be able to render them
 * accordingly in the resultcards.
 *
 * @param fullText
 * @returns {
 *  {
 *    beforeMatch: string,
 *    cleanedFullText: string | undefined,
 *    restText: string | undefined
 *  }
 * }
 */
export function getElasticHighlightRestText(fullText) {
    const [beforeMatch, restText] = fullText.split('<strong>');
    let cleanedFullText;
    if (!restText) {
        // nothing found
        // clear rest text of ending tag
        cleanedFullText = fullText.includes('</strong>')
            ? fullText.split('</strong>')[0]
            : fullText;
    }
    return { beforeMatch, cleanedFullText, restText };
}
export const ElasticHighlightedTextSingleMatch = ({ fullText, highlightedText, }) => {
    const { beforeMatch, cleanedFullText, restText } = getElasticHighlightRestText(fullText);
    if (restText) {
        const [matchText, afterMatch] = restText.split('</strong>');
        return (_jsxs("span", { children: [beforeMatch, _jsx(StrongStyled, { children: matchText.split(SPLITTING_CHARACTERS).map((matchTextPartial, i) => (_jsx(HighlightedText, { fullText: matchTextPartial, highlightedText: highlightedText }, i))) }), afterMatch] }));
    }
    return cleanedFullText;
};
export const ElasticHighlightedText = ({ fullText, highlightedText, }) => {
    if (!fullText)
        return null;
    const matchedChars = fullText.match(SPLITTING_CHARACTERS);
    return (_jsx("span", { children: fullText.split(SPLITTING_CHARACTERS).map((partialText, i) => {
            return (_jsxs("span", { children: [_jsx(ElasticHighlightedTextSingleMatch, { fullText: partialText, highlightedText: highlightedText }), matchedChars !== null && matchedChars[i] ? matchedChars[i] : ''] }, i));
        }) }));
};
